import styled from 'styled-components'
import { E_Colors } from '@/helpers/colors'

export const SC_DashboardMessagesWrapper = styled.div`
  width: 100%;
`

export const SC_DashboardMessagesBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid ${E_Colors.GrayEB};
  border-radius: 16px;
  border-top-right-radius: 4px;
  background-color: ${E_Colors.White};
  padding: 10px 10px 12px;
`

export const SC_DashboardMessagesTitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-bottom: 2px;
`

export const SC_DashboardMessagesTitleIcon = styled.span`
  color: ${E_Colors.MainColorAccent};
  margin-left: 0;
  margin-right: 8px;
  width: 22px;
  height: 22px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
    display: block;
  }
`

export const SC_DashboardMessagesTitle = styled.h3`
  color: ${E_Colors.TextPrimary};
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`

export const SC_DashboardMessageCard = styled.div`
  width: 100%;
  border: 1px solid ${E_Colors.GrayEB};
  border-radius: 12px;
  background-color: ${E_Colors.White};
  padding: 14px 12px;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${E_Colors.MainColorAccent};
    outline-offset: 2px;
  }
`

export const SC_DashboardMessageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`

export const SC_DashboardMessageSubject = styled.div`
  color: ${E_Colors.TextPrimary};
  font-size: 17px;
  font-weight: 400;
  line-height: normal;
`

export const SC_DashboardMessageDate = styled.div`
  color: ${E_Colors.Gray9C9CA1};
  font-size: 12px;
  margin-top: 3px;
`

export const SC_DashboardMessageClose = styled.button`
  border: 0;
  background: transparent;
  color: ${E_Colors.Gray9C9CA1};
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0;
`

export const SC_DashboardMessageContent = styled.div`
  margin-top: 10px;
  color: ${E_Colors.TextPrimary};
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
